import _Date$now from "@babel/runtime-corejs2/core-js/date/now";
import _Object$freeze from "@babel/runtime-corejs2/core-js/object/freeze";
import _regeneratorRuntime from "@babel/runtime-corejs2/regenerator";
import _toConsumableArray from "@babel/runtime-corejs2/helpers/toConsumableArray";
import _objectSpread from "@babel/runtime-corejs2/helpers/objectSpread";
import _asyncToGenerator from "@babel/runtime-corejs2/helpers/asyncToGenerator";
import _slicedToArray from "@babel/runtime-corejs2/helpers/slicedToArray";

/* eslint-disable no-mixed-operators */
import ReactCrop from 'react-image-crop';
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { ImageUploader, ImageUploaderFigure } from '@dmi-mch/components';
import { Cloudinary } from '@cloudinary/url-gen';
import { Icon, Button } from '@mch-group/uikit-components';
import { crop } from '@cloudinary/url-gen/actions/resize';
import Modal from './Modal';

var ImageCropMultipleWrap = function ImageCropMultipleWrap(_ref) {
  var labelObj = _ref.labelObj,
      configuration = _ref.configuration,
      name = _ref.name,
      defaultImages = _ref.defaultImages,
      hideRegularThumnbail = _ref.hideRegularThumnbail,
      hidePanoramicThumnbail = _ref.hidePanoramicThumnbail,
      callback = _ref.callback,
      thumbnailLabels = _ref.thumbnailLabels,
      placeholderMessage = _ref.placeholderMessage,
      thumbnailsTitle = _ref.thumbnailsTitle,
      thumbnailsSubtitle = _ref.thumbnailsSubtitle,
      thumbnailModalLabels = _ref.thumbnailModalLabels,
      _ref$mobileSlimFactor = _ref.mobileSlimFactor,
      mobileSlimFactor = _ref$mobileSlimFactor === void 0 ? 1 : _ref$mobileSlimFactor,
      _ref$regularImgSlimFa = _ref.regularImgSlimFactor,
      regularImgSlimFactor = _ref$regularImgSlimFa === void 0 ? 1.6 : _ref$regularImgSlimFa,
      _ref$panoramicImgSlim = _ref.panoramicImgSlimFactor,
      panoramicImgSlimFactor = _ref$panoramicImgSlim === void 0 ? 21 : _ref$panoramicImgSlim,
      isCustomizeRegularCropParams = _ref.isCustomizeRegularCropParams,
      figureHeight = _ref.figureHeight,
      _ref$customValidation = _ref.customValidation,
      customValidation = _ref$customValidation === void 0 ? {} : _ref$customValidation;
  // Create a Cloudinary instance and set your cloud name.
  // cld.image returns a CloudinaryImage with the configuration set.
  var cld = new Cloudinary({
    cloud: {
      cloudName: configuration.cloudinary.name || 'dqzqcuqf9'
    }
  });

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      isLoading = _useState2[0],
      setIsLoading = _useState2[1]; // The Thumbnail selected when clicking on a Thumbnail


  var _useState3 = useState(null),
      _useState4 = _slicedToArray(_useState3, 2),
      activeThumbnail = _useState4[0],
      setActiveThumbnail = _useState4[1]; // State that contains the crop selection of the active thumbnail


  var _useState5 = useState({}),
      _useState6 = _slicedToArray(_useState5, 2),
      cropValues = _useState6[0],
      setCropValues = _useState6[1];

  var tags = ['regular', 'panoramic', 'mobile'];
  var emptyList = tags.map(function (tag) {
    return {
      tag: tag,
      metadata: {}
    };
  }); // The 3 crops, in the same format that they are in the API.

  var _useState7 = useState(defaultImages || emptyList),
      _useState8 = _slicedToArray(_useState7, 2),
      allCrops = _useState8[0],
      setAllCrops = _useState8[1]; // The image that shows in the "large area" clickable. If no image, large area shows nothing.


  var mainImage = allCrops.find(function (image) {
    return image.tag === 'regular';
  }).metadata.originalImage;

  var _useState9 = useState(mainImage ? "https://res.cloudinary.com/".concat(configuration.cloudinary.name || 'dqzqcuqf9', "/image/fetch/w_370,q_60/").concat(mainImage) : null),
      _useState10 = _slicedToArray(_useState9, 2),
      largeImage = _useState10[0],
      setLargeImage = _useState10[1]; // When clicking to select an image, either removes the existing, or shows file prompt to upload a new one


  var selectImage = function selectImage(ref) {
    if (largeImage) {
      setAllCrops(emptyList);
      setLargeImage(null);
      callback(null);
    } else {
      ref.open();
    }
  }; // Once user clicks on Confirm inside the popup and is happy with a certain crop


  var onConfirmCrop = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var cropValuesForSaveCopy, currentCrop, allCropsCopy, selectedCrops;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              cropValuesForSaveCopy = _objectSpread({}, cropValues);
              currentCrop = {
                x: Math.round(cropValues.x * activeThumbnail.width / 100),
                y: Math.round(cropValues.y * activeThumbnail.height / 100),
                width: Math.round(cropValues.width * activeThumbnail.width / 100),
                height: Math.round(cropValues.height * activeThumbnail.height / 100)
              };
              setCropValues(cropValuesForSaveCopy);
              allCropsCopy = _toConsumableArray(allCrops);
              selectedCrops = allCropsCopy.map(function (img) {
                if (img.tag === activeThumbnail.tag) {
                  var myImage = cld.image(img.metadata.originalImage.split('/upload/')[1]);
                  myImage.resize(crop().width(currentCrop.width).height(currentCrop.height).x(currentCrop.x).y(currentCrop.y));
                  var croppedImage = myImage.toURL();

                  var imgCopy = _objectSpread({}, img);

                  imgCopy.url = croppedImage;
                  imgCopy.metadata.cropX = currentCrop.x;
                  imgCopy.metadata.cropY = currentCrop.y;
                  imgCopy.metadata.cropWidth = currentCrop.width;
                  imgCopy.metadata.cropHeight = currentCrop.height; // In case you want to remove... an image
                  // imgCopy.archived = true

                  return imgCopy;
                }

                return img;
              }); // Remove the active thumbnail (which will close the popup)

              setActiveThumbnail(null); // Replaces "allCrops" with the new ones

              setAllCrops(selectedCrops); // Sends the new crops "out"

              callback(selectedCrops);

            case 8:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function onConfirmCrop() {
      return _ref2.apply(this, arguments);
    };
  }(); // KEEP THIS JUST IN CASE THE "SMART" DEFAULT CROP DOESN'T WORK AS EXPECTED
  // const defaultCrop = {
  //   regular: {
  //     cropX: 20,
  //     cropY: 20,
  //     cropWidth: 464,
  //     cropHeight: 290
  //   },
  //   panoramic: {
  //     cropX: 20,
  //     cropY: 20,
  //     cropWidth: 1000,
  //     cropHeight: 266
  //   },
  //   mobile: {
  //     cropX: 20,
  //     cropY: 20,
  //     cropWidth: 400,
  //     cropHeight: 400
  //   }
  // }


  var thumbnailTitles = _Object$freeze(thumbnailLabels);

  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", null, isLoading && 'Loading...', /*#__PURE__*/React.createElement(ImageUploader, {
    accept: ".jpg,.jpeg,.jpe,.png",
    maxSize: 10485760,
    minWidth: customValidation && customValidation.minWidth || 2400,
    minHeight: customValidation && customValidation.minHeight || 1500,
    maxHeight: configuration.uploader ? configuration.uploader.maxHeight : null,
    maxWidth: configuration.uploader ? configuration.uploader.maxWidth : null,
    customValidation: customValidation,
    name: name,
    id: name,
    labelObj: labelObj.labelsValidation,
    api: "https://api.cloudinary.com/v1_1/".concat(configuration.cloudinary.name, "/image/upload"),
    uploadOnFileSelect: true,
    apiFormData: {
      upload_preset: configuration.uploadPreset.mfpOnlineShowImage,
      api_key: configuration.cloudinary.apiKey,
      timestamp: _Date$now() / 1000
    },
    onFileSelected: function onFileSelected(file) {
      setAllCrops(emptyList);
      setLargeImage(file);
      setIsLoading(true);
    },
    onFileUploadSuccess: function onFileUploadSuccess(file) {
      // Smart is not super smart, but enough smart for now
      var longerMeasureBetweenWidthAndHeight = file.data.width > file.data.height ? file.data.height : file.data.width;
      var smartDefaultCrops = {
        panoramic: {
          cropX: 0,
          cropY: Math.round((file.data.height - file.data.width * 7 / panoramicImgSlimFactor) / 2),
          cropWidth: Math.round(file.data.width),
          cropHeight: Math.round(file.data.width * 7 / panoramicImgSlimFactor)
        },
        mobile: {
          cropX: Math.round((file.data.width - longerMeasureBetweenWidthAndHeight / mobileSlimFactor) / 2),
          cropY: Math.round((file.data.height - longerMeasureBetweenWidthAndHeight) / 2),
          cropWidth: Math.round(longerMeasureBetweenWidthAndHeight / mobileSlimFactor),
          cropHeight: Math.round(longerMeasureBetweenWidthAndHeight)
        }
      };

      if (isCustomizeRegularCropParams) {
        smartDefaultCrops.regular = {
          cropX: Math.round((file.data.width - longerMeasureBetweenWidthAndHeight / regularImgSlimFactor) / 2),
          cropY: Math.round((file.data.height - longerMeasureBetweenWidthAndHeight / regularImgSlimFactor) / 2),
          cropWidth: Math.round(longerMeasureBetweenWidthAndHeight / regularImgSlimFactor),
          cropHeight: Math.round(longerMeasureBetweenWidthAndHeight)
        };
      } else {
        smartDefaultCrops.regular = {
          cropX: 0,
          cropY: Math.round((file.data.height - longerMeasureBetweenWidthAndHeight / regularImgSlimFactor) / 2),
          cropWidth: Math.round(file.data.width),
          cropHeight: Math.round(file.data.width / regularImgSlimFactor)
        };
      }
      /**
       * After the file is uploaded, it generates the 3 crops by using the
       * Cloudinary API. These crops are "automatic" (defined in JSON above).
       * After this, user will be free to change these crops.
       * This is already in a format that is both renderable (below)
       * and exportable to the BE API.
       */


      var newAllCrops = allCrops.map(function (item) {
        var myImage = cld.image(file.data.public_id);
        myImage.resize(crop().width(smartDefaultCrops[item.tag].cropWidth).height(smartDefaultCrops[item.tag].cropHeight).x(smartDefaultCrops[item.tag].cropX).y(smartDefaultCrops[item.tag].cropY));
        var croppedImage = myImage.toURL();
        return {
          url: croppedImage,
          tag: item.tag,
          width: file.data.width,
          height: file.data.height,
          metadata: _objectSpread({
            originalImage: file.data.url
          }, smartDefaultCrops[item.tag])
        };
      });
      setAllCrops(newAllCrops);
      callback(newAllCrops);
      setIsLoading(false);
    }
  }, function (ref) {
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(UploaderFigureStyled, null, /*#__PURE__*/React.createElement(ImageUploaderFigure, {
      onClick: function onClick() {
        return selectImage(ref);
      },
      placeholderMessage: placeholderMessage,
      imageUrl: largeImage,
      figureHeight: figureHeight
    })), /*#__PURE__*/React.createElement("div", {
      className: "field"
    }, /*#__PURE__*/React.createElement("label", null, thumbnailsTitle), /*#__PURE__*/React.createElement("div", {
      className: "label label-2",
      style: {
        marginBottom: '20px'
      }
    }, thumbnailsSubtitle), /*#__PURE__*/React.createElement(Thumbnails, null, allCrops.map(function (thumbnail) {
      if (hideRegularThumnbail && thumbnail.tag === 'regular') {
        return null;
      }

      if (hidePanoramicThumnbail && thumbnail.tag === 'panoramic') {
        return null;
      }

      return /*#__PURE__*/React.createElement(ThumbnailWrap, {
        key: thumbnail.tag
      }, /*#__PURE__*/React.createElement(Thumbnail, null, thumbnail.url && /*#__PURE__*/React.createElement("div", {
        role: "button",
        tabIndex: "0",
        onKeyDown: function onKeyDown() {},
        onClick: function onClick() {
          setActiveThumbnail(thumbnail);
          setCropValues({
            x: thumbnail.metadata.cropX / thumbnail.width * 100,
            y: thumbnail.metadata.cropY / thumbnail.height * 100,
            width: thumbnail.metadata.cropWidth / thumbnail.width * 100,
            height: thumbnail.metadata.cropHeight / thumbnail.height * 100,
            unit: '%',
            aspect: thumbnail.metadata.cropWidth / thumbnail.metadata.cropHeight
          });
        }
      }, /*#__PURE__*/React.createElement("img", {
        src: "https://res.cloudinary.com/".concat(configuration.cloudinary.name || 'dqzqcuqf9', "/image/fetch/w_217,q_60/").concat(thumbnail.url),
        alt: thumbnail.tag
      }), /*#__PURE__*/React.createElement(ThumbnailOverlay, {
        className: "overlay"
      }), /*#__PURE__*/React.createElement(EyeIconPositionCentering, null, /*#__PURE__*/React.createElement(Icon, {
        name: "eye-view",
        color: "white"
      })))), /*#__PURE__*/React.createElement("div", {
        className: "title"
      }, thumbnailTitles[thumbnail.tag]));
    }))));
  }), activeThumbnail && /*#__PURE__*/React.createElement(Modal, {
    center: true,
    open: true,
    onClose: function onClose() {
      return setActiveThumbnail(null);
    },
    closeOnEscape: false,
    closeOnDimmerClick: false
  }, /*#__PURE__*/React.createElement(ReactCrop, {
    src: "https://res.cloudinary.com/".concat(configuration.cloudinary.name || 'dqzqcuqf9', "/image/fetch/w_1000,q_60/").concat(activeThumbnail.metadata.originalImage),
    onChange: function onChange(cropChanged) {
      setCropValues(cropChanged);
    },
    crop: cropValues
  }), /*#__PURE__*/React.createElement("div", {
    className: "d-flex"
  }, /*#__PURE__*/React.createElement(Button, {
    className: "me-3",
    onClick: function onClick() {
      return setActiveThumbnail(null);
    },
    size: "small"
  }, thumbnailModalLabels.cancel), /*#__PURE__*/React.createElement(Button, {
    primary: true,
    onClick: onConfirmCrop,
    size: "small"
  }, thumbnailModalLabels.confirm)))));
};

var ThumbnailWrap = styled.div.withConfig({
  displayName: "ImageCropMultipleWrap__ThumbnailWrap",
  componentId: "sc-tli07e-0"
})([".title{margin-top:15px;}"]);
var EyeIconPositionCentering = styled.div.withConfig({
  displayName: "ImageCropMultipleWrap__EyeIconPositionCentering",
  componentId: "sc-tli07e-1"
})(["position:absolute;width:100%;height:100%;top:0;display:flex;flex-direction:row;justify-content:center;align-items:center;"]);
var ThumbnailOverlay = styled.div.withConfig({
  displayName: "ImageCropMultipleWrap__ThumbnailOverlay",
  componentId: "sc-tli07e-2"
})(["width:100%;height:100%;object-fit:contain;background:black;position:absolute;top:0;opacity:0;"]);
var Thumbnails = styled.div.withConfig({
  displayName: "ImageCropMultipleWrap__Thumbnails",
  componentId: "sc-tli07e-3"
})(["display:flex;flex-direction:row;"]);
var Thumbnail = styled.div.withConfig({
  displayName: "ImageCropMultipleWrap__Thumbnail",
  componentId: "sc-tli07e-4"
})(["&:hover{.overlay{opacity:0.2;transition:all 0.5s;}}cursor:pointer;width:176px;height:110px;background:#f7f7f7;display:flex;flex-direction:column;justify-content:center;position:relative;> div{height:100%;img{width:100%;height:100%;object-fit:contain;}svg{path{}}}margin-right:30px;"]); // Overwriting styleds for "Figure", that allows to click to upload a file

var UploaderFigureStyled = styled.div.withConfig({
  displayName: "ImageCropMultipleWrap__UploaderFigureStyled",
  componentId: "sc-tli07e-5"
})(["width:370px;height:272px;margin-bottom:50px;img{width:100%;object-fit:contain;height:100%;}.figure-overflow-icon{display:flex;flex-direction:row;align-items:center;justify-content:center;padding-top:0 !important;i{font-size:90%;}}.figure-placeholder{height:100%;display:flex;flex-direction:column;justify-content:center;padding-top:inherit !important;color:#757575;> div{color:#757575;font-size:15px;font-weight:bold;}}"]); // TODO: CLEAN THIS

ImageCropMultipleWrap.propTypes = {
  configuration: PropTypes.object,
  extraProps: PropTypes.object,
  labelObj: PropTypes.object,
  values: PropTypes.object,
  setFieldValue: PropTypes.func,
  imageValue: PropTypes.string,
  name: PropTypes.string,
  placeholderMessage: PropTypes.string,
  defaultImages: PropTypes.array,
  callback: PropTypes.func,
  hideRegularThumnbail: PropTypes.bool,
  hidePanoramicThumnbail: PropTypes.bool,
  thumbnailLabels: PropTypes.object,
  mobileSlimFactor: PropTypes.number,
  isCustomizeRegularCropParams: PropTypes.bool,
  regularImgSlimFactor: PropTypes.number,
  panoramicImgSlimFactor: PropTypes.number,
  thumbnailsTitle: PropTypes.string,
  thumbnailsSubtitle: PropTypes.string,
  thumbnailModalLabels: PropTypes.object,
  aspectRatioICardImg: PropTypes.string,
  aspectRatioIHeroImg: PropTypes.string,
  aspectRatioIMobileHeroImg: PropTypes.string,
  isNewClParams: PropTypes.bool,
  figureHeight: PropTypes.number,
  customValidation: PropTypes.object
};
export default ImageCropMultipleWrap;